// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixLocation from "wix-location";
//import wixWindow from 'wix-window';

import wixWindow from 'wix-window';
let formFactor;

$w.onReady(function () {
	//const desktop = wixWindow.formFactor === 'Desktop';

formFactor = wixWindow.formFactor;
	
	var templates = "https://www.wix.com/wix-lp/designers-playground/templates";
	if (wixLocation.url === templates) {
		// $w('#button104').link = "https://editor.wix.com/html/editor/web/renderer/new?metaSiteId=ebbec735-2eab-4879-8011-00885f4cacde&siteId=c41d20fe-577c-4c3d-98ff-c8c149faee17&editorSessionId=585A29D0-9C29-492C-9720-742030E581D3";
	} else {
		// $w('#button104').link = templates;
	}
//
//	$w('#repeater1').forEachItem(($item, itemData, index) => {
//		if (index >= 4) {
//			$item('#container1').collapse()
//		}
//	})

//	$w('#button213').onClick(() => {
//		$w('#repeater1').forEachItem(($item, itemData, index) => {
//			if (index >= 4) {
//				$item('#container1').expand()
//			}
//		})
//	})
});

//		.then(()=>{
//			console.log('hide temp');
//			return $w(textId).hide('FadeOut');
//		})
//		.then(()=>{
//			console.log('change temp');
//			$w(textId).text = newText;
//		})
//		.then(()=>{
//			console.log('show temp');
//			return $w(textId).show('FadeIn');
//		})
//		.then(()=>{
//			console.log('show deg');
//			return $w('#shape6').show('FadeIn');
//		});
//	}
//}


$w.onReady(function () {
    $w("#container2").onMouseIn((event, $w) => {
        let $item = $w.at(event.context);
        
    $w('#imagcircule').show()
	$w('#imageHover').hide()

    });

	$w("#container2").onMouseOut((event, $w) => {
        let $item = $w.at(event.context);

    $w('#imagcircule').hide()
	$w('#imageHover').show()

    });

    });


// export function dataset3_ready() {
//	if (formFactor === 'Mobile') {
//		$w("#dataset3").setPageSize(5)
//		.then( () => {
//			console.log("Page size set.");
//		} )
//		.catch( (err) => {
//			let errMsg = err.message;
//			let errCode = err.code;
//		} );
//	} 
//}